/*
  Version: v01
  File: CertifiedBankCardTermsOfServicePage_v01.tsx
  Description: A2P compliant Terms of Service page for CertifiedBankCard.com.
*/

import React from 'react';
import { Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import CertifiedBankCardHeader_v01 from './CertifiedBankCardHeader_v01';
import CertifiedBankCardFooter_v01 from './CertifiedBankCardFooter_v01';

export default function CertifiedBankCardTermsOfServicePage_v01(): React.JSX.Element {
  return (
    <div className="bg-white text-dark">
      <CertifiedBankCardHeader_v01 />
      <section className="py-5">
        <Container style={{ maxWidth: '900px' }}>
          <h1 className="display-5 fw-bold mb-4">Terms of Service</h1>
          <p className="text-muted">Effective date: April 23, 2026</p>

          <h2 className="h4 mt-4">1. Use of This Website</h2>
          <p>
            This website is provided by CertifiedBankCard.com to share information about payment processing, business funding,
            financial services, and related business solutions. By using this website, you agree to use it only for lawful purposes.
          </p>

          <h2 className="h4 mt-4">2. No Guarantee of Approval or Availability</h2>
          <p>
            Information submitted through this site does not guarantee approval for merchant services, financing, or any related service.
            All programs, pricing, approvals, and product availability are subject to review and change.
          </p>

          <h2 className="h4 mt-4">3. User Submissions</h2>
          <p>
            When you submit a request through this website, you agree that the information you provide is accurate to the best of your knowledge.
            You understand that we may use the information you submit to contact you about your inquiry and relevant services.
          </p>

          <h2 className="h4 mt-4">4. SMS / A2P Communications</h2>
          <p>
            By providing your phone number through this website, you agree that CertifiedBankCard.com may contact you by phone or text message
            regarding your request, account-related follow-up, service-related updates, and related business communications where permitted.
          </p>
          <p>
            SMS consent is not a condition of purchase. Message and data rates may apply. Message frequency may vary. You can reply STOP to opt out
            of SMS messages at any time and reply HELP for help.
          </p>

          <h2 className="h4 mt-4">5. Privacy</h2>
          <p>
            Your use of this website is also subject to our <Link to="/privacy-policy">Privacy Policy</Link>, which explains how we collect,
            use, and store information submitted through this website.
          </p>

          <h2 className="h4 mt-4">6. Intellectual Property</h2>
          <p>
            The content, branding, layout, and materials on this website are owned by or used with permission by CertifiedBankCard.com and may not
            be copied, republished, or distributed without permission.
          </p>

          <h2 className="h4 mt-4">7. Disclaimer</h2>
          <p>
            This website and its content are provided on an “as is” and “as available” basis without warranties of any kind, except as required by law.
          </p>

          <h2 className="h4 mt-4">8. Limitation of Liability</h2>
          <p>
            To the fullest extent allowed by law, CertifiedBankCard.com will not be liable for any indirect, incidental, special, or consequential damages
            resulting from use of this website or reliance on its content.
          </p>

          <h2 className="h4 mt-4">9. Changes to These Terms</h2>
          <p>
            We may update these Terms of Service from time to time. Updated versions will be posted on this page with a revised effective date.
          </p>
        </Container>
      </section>
      <CertifiedBankCardFooter_v01 />
    </div>
  );
}

/*
  File Name: CertifiedBankCardTermsOfServicePage_v01.tsx
  Quick Description: A2P compliant Terms of Service page component.
  Version: v01
*/
